<template>
  <div id="app">
    <div class="snackbar" v-if="snackWithButtons">
       <span>New version available</span>
       <button
         v-on:click="refreshApp"
         class="btn btn-success center-block btn-green ml-2"
       >
         Refresh
       </button>
     </div>
    <router-view/>
  </div>
</template>
<script>
import moment from 'moment'
import CommonConstants from '@/constants/constants.js'
export default {
  name: 'App',
  data() {
   return {
     show: 0,
     refreshing: false,
     registration: null,
     snackWithButtons: false,
   };
  },
  beforeCreate: function () {
    if (localStorage.getItem('wasReset') === null) {
      localStorage.setItem('wasReset', moment().format('DDMMYYYY'))
    } else {
      if (localStorage.getItem('wasReset') != moment().format('DDMMYYYY')) {
        this.$router.push('/logout')
        localStorage.setItem('wasReset', moment().format('DDMMYYYY'))
      }
    }
    this.$session.start()
    this.$session.set('tempUrl', this.$route.fullPath)
    console.log(this.$session.get('tempUrl'));

    if (!this.$session.has('token') && !localStorage.getItem('token')) {
      if (this.$route.path == '/auth/password/reset') {
        this.$router.push('/auth/password/reset').catch(err => {})
      }
      else if(this.$route.matched[0] && this.$route.matched[0].path == "/auth/reset/:token/:email") {
      }else{
        this.$router.push('/login').catch(err => {})
      }

    } else {


      if (this.$session.get('tempUrl') == '/') {
        this.$router.push('timesheets').catch(err => {})
      }
    }
  },
  mounted: function () {
    if(localStorage.getItem('token'))
      this.checkSession()
  },
  created() {
   // Listen for swUpdated event and display refresh snackbar as required.
   document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
   // Refresh all open app tabs when a new service worker is installed.
   navigator.serviceWorker.addEventListener("controllerchange", () => {
     if (this.refreshing) return;
     this.refreshing = true;
     window.location.reload();
   });
  },
  methods:{
      checkSession(){
            let self = this;
            let token = localStorage.getItem('token');
            axios.get(CommonConstants.api_url + 'checkSessionInactivity', {
                headers: {
                    'Content-type': "application/json",
                    'token': token,
                    'checkSessionFlag': true
                }
                }).then(function (result) {
                    if(result.data.flag == false){
                        console.log('session destroyed');
                        self.$session.destroy()
                        localStorage.removeItem("token")
                        localStorage.removeItem("userData")
                        self.$router.push('/login')
                        self.$router.go();
                    }else{
                      if(self.$route.fullPath =='/logout')
                        self.$router.push('/timesheets')
                    }
                }).catch(function (error) {
                    console.log("session expired");
            })
      },
       showRefreshUI(e) {
        // Display a snackbar inviting the user to refresh/reload the app due
        // to an app update being available.
        // The new service worker is installed, but not yet active.
        // Store the ServiceWorkerRegistration instance for later use.
        this.registration = e.detail;
        this.snackWithButtons = true;
      },
      refreshApp() {
        this.snackWithButtons = false;
        // Protect against missing registration.waiting.
        if (!this.registration || !this.registration.waiting) {
          return;
        }this.registration.waiting.postMessage("skipWaiting");
      }
  }
}
</script>



<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

</style>
<style>
.snackbar {
  position: fixed;
  left: 10px;
  bottom: 10px;
  color: white;
  background: #202124;
  padding: 10px;
  border-radius: 5px;
}
</style>
